import { createFileRoute } from "@tanstack/react-router";
import { shortLinkRoute, ShortLinkRedirect } from "@/lib/core/short-links";

export const Route = createFileRoute("/$")({
    beforeLoad: shortLinkRoute.beforeLoad,
    loader: shortLinkRoute.loader,
    component: ShortLinkRedirect,
});
